@if (crmService.wizardLoading().isLoadingWizardStepAction) {
<zint-loader class="mx-auto" size="small" [overlay]="true" [dotColor]="'var(--zint-grey-500)'"></zint-loader>
}
@if (!crmService.wizardLoading().isLoadingWizardStepAction) {
<div div class="mb-2">
  @for (fieldType of matcherFieldTypes; track $index) {
  <div class="mb-3">
    <span class="text-bold-600">{{fieldType.label}}</span>
    <zint-autocomplete [options]="crmProperties" [displayProperty]="'label'"
      [label]="'Select ' + (crmType | titlecase) + ' field for ' + fieldType.label" [subscriptKey]="'name'"
      [preSelectedValue]="selectedMatcherFields[fieldType.value]?.crmField" [showIcon]="true"
      (optionSelected)="onMatcherFieldSelected(fieldType.value, $event)"
      (inputCleared)="onMatcherFieldCleared(fieldType.value)">
    </zint-autocomplete>
  </div>
  }


  <details class="mt-4">
    <summary class="text-grey-600 u-offset-25">Advanced Matching Options (Optional)</summary>
    <div class="d-flex flex-column mb-1 mt-2">
      <span class="mb-2">Minimum Acceptable Match Rate: {{minimumAcceptableMatchRate}}%
        <small class="text-sup" role="button" matTooltip="Help" (click)="toggleAdvancedOptionModal()">
          <i class="fas fa-circle-info text-vivid-blue"></i>
        </small>
      </span>
      <div class="custom-slider">
        <ngx-slider [(value)]="minimumAcceptableMatchRate" [options]="sliderOptions"
          (userChangeEnd)="onMinimumMatchRateChange($event)">
        </ngx-slider>
      </div>
    </div>
  </details>

  <div class="mt-4">
    <button
      class="rounded-btn-base rounded-btn-vivid btn-p-md w-100"
      [disabled]="isCompanyMatcherRunning"
      [class.rounded-btn-grey]="isCompanyMatcherRunning"
      [class.rounded-btn-vivid]="!isCompanyMatcherRunning"
      (click)="triggerCompanyMatcher()"
      [matTooltip]="isCompanyMatcherRunning ? 'Company matcher process is running' : 'Trigger company matching process for this CRM object'">
      @if (isCompanyMatcherRunning) {
        <i class="fas fa-spinner fa-spin mr-2"></i>
        Running Company Matcher...
      } @else {
        <i class="fas fa-rocket mr-2"></i>
        Run Company Matcher
      }
    </button>
  </div>
</div>

@if (showAdvancedOptionsModal) {
  <zint-modal [modalConfig]="advancedHelpModalConfig" [modalContent]="advancedHelpModalContent"></zint-modal>
}
}